import React from 'react';
import { Users, Mail, QrCode, Calendar, User } from 'lucide-react';
import { useUI } from '../contexts/UIContext';
import { useAuth } from '../contexts/AuthContext';
import { SCREENS } from '../utils/constants';
import withTranslation from '../hoc/withTranslation';

/**
 * Alt navigasyon bileşeni
 * 
 * @param {Object} props - Bileşen özellikleri
 * @param {string} props.activeItem - Aktif öğe kimliği
 * @param {Function} props.t - Çeviri fonksiyonu (withTranslation HOC'u tarafından eklenir)
 */
const BottomNavigation = ({ activeItem, t }) => {
  const { navigateToScreen, showBiometricVerification } = useUI();
  const { isAuthenticated } = useAuth();

  // Navigation items - Updated for IdentityCircle
  const navigationItems = [
    { id: 'identityCircle', icon: 'Users', label: 'IdentityCircle', screen: SCREENS.IDENTITY_CIRCLE },
    { id: 'messages', icon: 'Mail', label: 'Mesajlar', screen: SCREENS.MESSAGING },
    { id: 'qr', icon: 'QrCode', label: 'QR', screen: SCREENS.QR_SCANNER },
    { id: 'today', icon: 'Calendar', label: 'Bugün', screen: SCREENS.TODAY },
    { id: 'profile', icon: 'User', label: 'Profil', screen: SCREENS.PROFILE }
  ];

  // Öğe simgesini al
  const getIcon = (iconName, size = 24) => {
    switch (iconName) {
      case 'Users':
        return <Users size={size} />;
      case 'Mail':
        return <Mail size={size} />;
      case 'QrCode':
        return <QrCode size={size} />;
      case 'Calendar':
        return <Calendar size={size} />;
      case 'User':
        return <User size={size} />;
      default:
        return null;
    }
  };

  // Öğeye tıklama işleyicisi
  const handleItemClick = (item) => {
    // Kullanıcı kimlik doğrulaması yapmamışsa, giriş ekranına yönlendir
    if (!isAuthenticated) {
      navigateToScreen('login');
      return;
    }

    if (item.id === 'vault') {
      // Kasa için güvenlik doğrulaması
      const completeVerification = showBiometricVerification(() => {
        navigateToScreen(item.screen);
      });

      // Biyometrik doğrulama kullanılamıyorsa veya devre dışı bırakılmışsa
      if (!completeVerification) {
        navigateToScreen(item.screen);
      }
    } else if (item.id === 'qr') {
      // QR okuyucu - Arkadaş ekleme ve QR tarama için özel işlem
      navigateToScreen('qrScanner');
    } else {
      navigateToScreen(item.screen);
    }
  };

  return (
    <nav className="backdrop-blur-xl bg-white/70 dark:bg-gray-900/60 border-t border-white/20 dark:border-gray-700/40 py-2 fixed bottom-0 left-0 right-0 shadow-lg z-40">
      <div className="flex justify-around">
        {navigationItems.map((item) => (
          <button
            key={item.id}
            className={`p-2 flex flex-col items-center ${activeItem === item.id ? 'text-indigo-600 dark:text-indigo-400' : 'text-gray-500 dark:text-gray-400'
              }`}
            onClick={() => handleItemClick(item)}
          >
            {getIcon(item.icon)}
            <span className="text-xs mt-1">{t(`nav.${item.id}`, item.label)}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

// withTranslation HOC ile sarmalanmış bileşeni dışa aktar
export default withTranslation(BottomNavigation);